import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Chip,
  Stack,
} from '@mui/material';

import { Supplier } from '@domain/suppliers/models/Supplier';
import { format } from 'date-fns';

interface SuppliersTableProps {
  suppliers: Supplier[];
}

export const SuppliersTable: React.FC<SuppliersTableProps> = ({ suppliers }) => {
  const navigate = useNavigate();

  return (
    <TableContainer>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={{ px: 3 }}>Supplier</TableCell>
            <TableCell sx={{ px: 3, minWidth: 220 }}>Contact</TableCell>
            <TableCell sx={{ px: 3 }}>Main address</TableCell>
            <TableCell sx={{ width: 120, px: 3 }}>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {suppliers.map(supplier => (
            <TableRow
              key={supplier.id}
              hover
              onClick={() => navigate(`/suppliers/${supplier.id}`)}
              sx={{
                cursor: 'pointer',
                '& td': {
                  borderBottom: 1,
                  borderColor: 'divider',
                  py: 2,
                },
              }}
            >
              <TableCell sx={{ px: 3 }}>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 'medium',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {supplier.name}
                </Typography>
              </TableCell>
              <TableCell sx={{ px: 3 }}>
                <Stack spacing={0.25} direction="row" alignItems="center" justifyContent="flex-start">
                  {supplier.email && (
                    <Typography variant="body2">{supplier.email}</Typography>
                  )}

                  {supplier.phone && (
                    <Typography variant="body2" color="text.secondary">
                      {supplier.phone}
                    </Typography>
                  )}

                  {!supplier.email && !supplier.phone && (
                    <Typography variant="body2" color="text.secondary">
                      Not set
                    </Typography>
                  )}
                </Stack>
              </TableCell>
              <TableCell sx={{ px: 3 }}>
                {supplier.addresses.length > 0 && supplier.addresses.find(address => address.isPrimary) ? (
                  <Typography variant="body2" color="text.secondary">
                    {supplier.addresses.find(address => address.isPrimary)?.address}
                  </Typography>
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    Not set
                  </Typography>
                )}
              </TableCell>
              <TableCell sx={{ px: 3 }}>
                <Chip
                  label={supplier.isActive ? 'Active' : 'Inactive'}
                  color={supplier.isActive ? 'success' : 'default'}
                  size="small"

                />
              </TableCell>

            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
